import type { MacroElementRequestAPI, MacroElementResponseAPI } from '../types/element';
import { fetchAndParse } from '../utils/ajax';
import { getTenantId } from '../utils/tenant';

export const getMacro = async (id: string) =>
    fetchAndParse<MacroElementResponseAPI>({
        url: `/api/draw/1/element/macro/${id}`,
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });

export const getAllMacros = async () =>
    fetchAndParse<MacroElementResponseAPI[]>({
        url: '/api/draw/1/element/macro',
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });

export const saveMacro = async (request: MacroElementRequestAPI) =>
    fetchAndParse<MacroElementResponseAPI>({
        url: '/api/draw/1/element/macro',
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ManyWhoTenant: getTenantId(),
        },
        body: request,
    });

export const deleteMacro = async (id: string) =>
    fetchAndParse<void>({
        url: `/api/draw/1/element/macro/${id}`,
        method: 'delete',
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });
